import { combineReducers, Reducer, ReducersMapObject } from "redux";
import { reducer as formReducer } from "redux-form";

import { GlobalState } from "@app/models/state";
import { api } from "@api/reducers";
import { auth } from "@auth/reducers";
import { localisation } from "@localisation/reducers";
import { reports } from "@reports/reducers";
import { sales } from "@sales/reducers";
import { charts } from "@charts/reducers";
import { deliveries } from "@deliveries/reducers";
import { dsps } from "@dsps/reducers";
import { music } from "@music/reducers";
import { oldwata } from "@oldwata/reducers";
import { files } from "@files/reducers";
import { search } from "@search/reducers";
import { upload } from "@upload/reducers";
import { vendor } from "@vendor/reducers";
import { reducers as formReducers } from "./form";

const rootReducer: Reducer<GlobalState> = combineReducers<GlobalState>({
    form: formReducer.plugin(formReducers),
    api,
    auth,
    localisation,
    reports,
    sales,
    charts,
    deliveries,
    dsps,
    music,
    oldwata,
    files,
    search,
    upload,
    vendor,
} as ReducersMapObject);

export { rootReducer };
